import { __awaiter, __generator } from "tslib";
import { FileType } from '@office-start/document-types';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { appendLoginHint } from '@office-start/url-parser-utility';
import { getRequestIdFromResponse, httpPost } from '@office-start/xhr-service';
import { OneNoteEndpoint } from '../../models/Constants';
import { getGraphServiceEndpoint } from '../../utilities/getGraphServiceEndpoint';
function isGraphError(response) {
    return 'error' in response;
}
export function createNewNotebook(createNewNotebookOptions, displayName) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, postBody, graphServiceHost, url, requestConfig;
        return __generator(this, function (_a) {
            if (!createNewNotebookOptions) {
                return [2 /*return*/, Promise.reject({
                        clientError: 'Invalid createNewNotebookOptions',
                    })];
            }
            endpoint = "".concat(OneNoteEndpoint);
            postBody = {
                displayName: displayName,
            };
            graphServiceHost = createNewNotebookOptions.inMockMode
                ? createNewNotebookOptions.officeHomeApiRoot
                : createNewNotebookOptions.graphApiRoot;
            url = getGraphServiceEndpoint(graphServiceHost, endpoint, false);
            requestConfig = {
                headers: {
                    category: 'CreateFile',
                    fileType: FileType.OneNote,
                },
            };
            return [2 /*return*/, httpPost(KnownInstrumentationEvents.OneNoteGraphCreateNoteBookRequest, "OneNote_Graph_Create_NoteBook" /* KnownRequestInstrumentationEvents.OneNoteGraphCreateNoteBookRequest */, url, postBody, requestConfig, createNewNotebookOptions.jwtAuthEnabled, createNewNotebookOptions.getAccessToken, createNewNotebookOptions.officeHomeApiRoot, createNewNotebookOptions.officeCorrelationId, 'Graph', {
                    populateRequestEvent: function (response, params) {
                        params["RequestId" /* InstrumentationParam.RequestId */] =
                            getRequestIdFromResponse(response) || '';
                    },
                })
                    .then(function (response) {
                    if (!response || !response.data || isGraphError(response)) {
                        throw new Error((response === null || response === void 0 ? void 0 : response.statusText) ||
                            'Could not parse notebook item from Graph response');
                    }
                    else {
                        var item = response.data;
                        // TODO: Are there previous/valid scenarios that make these granular checks necessary
                        if (item &&
                            item.links &&
                            item.links.oneNoteWebUrl &&
                            createNewNotebookOptions.loginHint) {
                            // Resolve new Notebook url href
                            return appendLoginHint(item.links.oneNoteWebUrl.href, createNewNotebookOptions.loginHint, createNewNotebookOptions.loginHintEnabled);
                        }
                        else {
                            throw new Error(createNewNotebookOptions.loginHint
                                ? 'Invalid Notebook item returned'
                                : 'Invalid loginHint provided in notebook creation');
                        }
                    }
                })
                    .catch(function (error) {
                    logError({
                        eventName: 'OneNote_Graph_Create_NoteBook_Error',
                        errorType: 'OneNote_Notebook_Create_Error',
                        message: error.httpResponse.data.error.message,
                    });
                    return undefined;
                })];
        });
    });
}
//# sourceMappingURL=createNewNotebook.js.map